<template>
  <div class="flex">
    <img :src="star" alt="star" class="star" />
    <img :src="star" alt="star" class="star" />
    <img :src="star" alt="star" class="star" />
    <img :src="star" alt="star" class="star" />
    <img :src="star" alt="star" class="star" />
    <span class="rating-text">{{ $t("scene_productdetails.ratingText") }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      star: "/assets/favorite.png",
    };
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: start;
}

.star {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.rating-text {
  font-size: 1em;
  color: #8f7229;
  display: block;
  text-align: start;
  font-family: "Roc Grotesk Light", sans-serif;
  white-space: nowrap;
}
</style>
